export default function EventDetails() {
  return (
    <section id="event-details" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <div className="w-16 h-px bg-gray-800 mx-auto mb-6"></div>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-gray-900 mb-4">Event Details</h2>
          <p className="text-gray-600 text-sm sm:text-base font-light tracking-wide">
            Join us for an unforgettable evening
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
          <div className="bg-white p-8 sm:p-10 text-center shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
              <i className="ri-calendar-event-line text-4xl text-gray-800"></i>
            </div>
            <h3 className="font-serif text-xl sm:text-2xl text-gray-900 mb-3">Ceremony</h3>
            <p className="text-gray-600 text-sm font-light tracking-wide mb-2">June 18th, 2026</p>
            <p className="text-gray-600 text-sm font-light tracking-wide">6:00 PM</p>
          </div>

          <div className="bg-white p-8 sm:p-10 text-center shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
              <i className="ri-map-pin-line text-4xl text-gray-800"></i>
            </div>
            <h3 className="font-serif text-xl sm:text-2xl text-gray-900 mb-3">Location</h3>
            <p className="text-gray-600 text-sm font-light tracking-wide mb-2">Mildred B Cooper Chapel</p>
            <p className="text-gray-600 text-sm font-light tracking-wide">504 Memorial Drive</p>
            <p className="text-gray-600 text-sm font-light tracking-wide">Bella Vista, AR 72714</p>
          </div>

          <div className="bg-white p-8 sm:p-10 text-center shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
              <i className="ri-goblet-line text-4xl text-gray-800"></i>
            </div>
            <h3 className="font-serif text-xl sm:text-2xl text-gray-900 mb-3">Reception</h3>
            <p className="text-gray-600 text-sm font-light tracking-wide mb-2 font-semibold">Adult Only Reception</p>
            <p className="text-gray-600 text-sm font-light tracking-wide mb-2">Onyx</p>
            <p className="text-gray-600 text-sm font-light tracking-wide mb-2">101 E Walnut St.</p>
            <p className="text-gray-600 text-sm font-light tracking-wide mb-2">Heavy Hors d'oeuvres & Dancing</p>
            <p className="text-gray-600 text-sm font-light tracking-wide">Beer & Wine</p>
          </div>
        </div>

        {/* Travel Information Section */}
        <div className="mt-12 sm:mt-16 max-w-5xl mx-auto bg-white p-8 sm:p-12 shadow-sm">
          <div className="text-center mb-8 sm:mb-10">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-plane-line text-4xl text-gray-800"></i>
            </div>
            <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-4">Travel Information</h3>
            <p className="text-gray-600 text-sm sm:text-base font-light tracking-wide max-w-2xl mx-auto">
              Flying in for our special day? Here are the two closest airports to our venue
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 mb-8">
            <div className="bg-gray-50 p-6 sm:p-8 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-flight-takeoff-line text-3xl text-gray-800"></i>
              </div>
              <h4 className="font-serif text-xl sm:text-2xl text-gray-900 mb-2">XNA</h4>
              <p className="text-gray-600 text-sm font-light tracking-wide mb-1">Northwest Arkansas</p>
              <p className="text-gray-600 text-sm font-light tracking-wide mb-1">National Airport</p>
              <p className="text-gray-600 text-xs font-light tracking-wide text-gray-500 mt-3">Closest Option</p>
            </div>

            <div className="bg-gray-50 p-6 sm:p-8 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-flight-takeoff-line text-3xl text-gray-800"></i>
              </div>
              <h4 className="font-serif text-xl sm:text-2xl text-gray-900 mb-2">TUL</h4>
              <p className="text-gray-600 text-sm font-light tracking-wide mb-1">Tulsa International</p>
              <p className="text-gray-600 text-sm font-light tracking-wide mb-1">Airport</p>
              <p className="text-gray-600 text-xs font-light tracking-wide text-gray-500 mt-3">Alternative Option</p>
            </div>
          </div>

          <div className="text-center">
            <a
              href="https://www.google.com/travel/flights"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gray-900 text-white px-8 py-4 hover:bg-gray-800 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line text-xl"></i>
              <span className="text-sm font-light tracking-wide">Search Flights on Google</span>
            </a>
          </div>
        </div>

        {/* Chapel Showcase */}
        <div className="mt-12 sm:mt-16 max-w-5xl mx-auto">
          <div className="relative h-64 sm:h-80 md:h-96 w-full overflow-hidden shadow-lg">
            <img
              src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/2b4b13acfe7d3ac1f7b5b626406ebc66.webp"
              alt="Mildred B Cooper Chapel Exterior"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="text-center mt-6 sm:mt-8 px-4">
            <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-4">The Mildred B Cooper Memorial Chapel</h3>
            <p className="text-gray-600 text-sm font-light tracking-wide max-w-3xl mx-auto leading-relaxed">
              A breathtaking architectural masterpiece nestled in the Ozark woods of Bella Vista, Arkansas. 
              This stunning glass chapel features soaring wooden beams and floor-to-ceiling windows that bring 
              the beauty of nature inside, creating an unforgettable setting for our special day.
            </p>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 max-w-3xl mx-auto bg-white p-8 sm:p-12 shadow-sm">
          <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-6 text-center">Dress Code</h3>
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-shirt-line text-3xl text-gray-800"></i>
            </div>
            <p className="text-xl sm:text-2xl font-light tracking-widest text-gray-900">BLACK TIE</p>
          </div>
          <p className="text-gray-600 text-sm font-light tracking-wide text-center px-4">
            We kindly request formal attire for our special evening. Tuxedos and black gowns are encouraged.
          </p>
        </div>

        {/* Rental Options Section */}
        <div className="mt-12 sm:mt-16 max-w-3xl mx-auto bg-white p-8 sm:p-12 shadow-sm">
          <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-6 sm:mb-8 text-center">Need a Suit or Dress?</h3>
          <p className="text-gray-600 text-sm sm:text-base font-light tracking-wide text-center mb-6 sm:mb-8 px-4">
            Here are a few rental sites that may help
          </p>
          
          <div className="grid sm:grid-cols-2 gap-6">
            <a 
              href="https://www.azazie.com/all/atelier-formal-dresses/colors-family/black"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gray-50 p-6 sm:p-8 text-center hover:bg-gray-100 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-women-line text-3xl text-gray-800 group-hover:scale-110 transition-transform duration-300"></i>
              </div>
              <h4 className="font-serif text-lg sm:text-xl text-gray-900 mb-2">Formal Gowns</h4>
              <p className="text-gray-600 text-sm font-light tracking-wide mb-3">
                Browse elegant black formal dresses
              </p>
              <span className="text-gray-800 text-sm font-light tracking-wide underline">Visit Azazie</span>
            </a>

            <a 
              href="https://generationtux.com/collection/tuxedos-and-suits"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gray-50 p-6 sm:p-8 text-center hover:bg-gray-100 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-3-line text-3xl text-gray-800 group-hover:scale-110 transition-transform duration-300"></i>
              </div>
              <h4 className="font-serif text-lg sm:text-xl text-gray-900 mb-2">Tux or Suit Rental</h4>
              <p className="text-gray-600 text-sm font-light tracking-wide mb-3">
                Find the perfect tuxedo or suit
              </p>
              <span className="text-gray-800 text-sm font-light tracking-wide underline">Visit Generation Tux</span>
            </a>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block relative">
            <div className="absolute -top-4 -left-4 w-32 h-32 opacity-20">
              <img
                src="https://public.readdy.ai/ai/img_res/98a60f7f73eb50389cb61e46309b3f60.jpg"
                alt="Decorative Ribbon"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}